<template>
  <div class="container">
    <router-view></router-view>
    <van-loading class="my-loading" size="56px"  v-if="loading" />
  </div>
</template>
<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isShowTitleRight: false,
    };
  },
  computed: {
    ...mapGetters(["loading", "leftArrow"]),
  },
  methods: {
    onClickLeft() {},
    onClickRight() {},
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 100%;
  background: $color-bg;
  position: relative;
  .my-loading {
    color: $color-primary;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
